import { render, staticRenderFns } from "./GetPlan.vue?vue&type=template&id=68d24e59&scoped=true&"
import script from "./GetPlan.vue?vue&type=script&lang=js&"
export * from "./GetPlan.vue?vue&type=script&lang=js&"
import style0 from "./GetPlan.vue?vue&type=style&index=0&id=68d24e59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d24e59",
  null
  
)

export default component.exports